import {MarkerClusterer} from "@googlemaps/markerclusterer";
import markerUri from '../../../dist/images/map-marker-green.png';
import clusterUri from '../../../dist/images/marker-cluster-green.png';

let mapMarkers = [];
let googleMapMarkers = [];
let markerClusters = [];
let fitBounds = 0;

const urlParams = (new URL(document.location)).searchParams;
const urlParamOperator = urlParams.get('operator') ? urlParams.get('operator') : 'all';
const urlParamCity = urlParams.get('city') ? urlParams.get('city') : 'all';

export default function initializeMap() {
    let mapElement = document.getElementById('fp-map');
    if(mapElement) {
        const loadGoogleMapsApi = require('load-google-maps-api');
        loadGoogleMapsApi({key: 'AIzaSyAtDAAZp3n4hsnv7bqIpziWlKzk-5Jzihw'}).then(function (googleMaps) {
            initializeWtbForm();
            initGoogoleMap(googleMaps);
        }).catch(function (error) {
            console.error(error)
        });
    }
}

function initializeWtbForm() {
    let operatorSelect = document.querySelector('#fp-operator');
    let cityInput = document.querySelector('#fp-city');

    if (urlParamOperator !== 'all') {
        operatorSelect.value = urlParamOperator;
    }

    if (urlParamCity !== 'all') {
        cityInput.value = urlParamCity;
    }

    operatorSelect.addEventListener('change', function () {
        let searchButton = document.querySelector('#fp-submit');
        searchButton.click();
    });
}

function filterPoints(map, googleMaps) {
    let searchButton = document.querySelector('#fp-submit'),
        operatorSelect = document.querySelector('#fp-operator'),
        cityInput = document.querySelector('#fp-city'),
        container = document.querySelector('.fp-points');

    searchButton.addEventListener('click', function (e) {
        e.preventDefault();

        let loader = document.querySelector('.block-find-place__loader');
        loader.style.display = 'flex';
        container.style.display = 'none';

        for (let i = 0; i < markerClusters.length; i++) {
            markerClusters[i].removeMarkers(googleMapMarkers);
        }
        for (let i = 0; i < googleMapMarkers.length; i++) {
            googleMapMarkers[i].setMap(null);
        }
        googleMapMarkers = [];
        mapMarkers = [];

        let operator = operatorSelect.value;
        let city = cityInput.value;

        loadAjaxStores(city, operator).then(data => {
            let points = data.results;

            for (let i = 0; i < points.length; i++) {

                const posLatLong = points[i].fields.pos_lat_long.split(',');

                addMapMarker(parseFloat(posLatLong[0]), parseFloat(posLatLong[1]), points[i].id);
            }

            showMapMarkers(map, googleMaps);

            addPoints(points);
            loader.style.display = 'none';
            container.style.display = 'flex';
        });
    });
}

function addPoints(points) {
    let container = document.querySelector('.fp-points');
    container.innerHTML = '';

    let html = '';

    const limit = 40;

    if(points.length === 0) {
        html =
            '<div class="block-find-place__point">' +
            '<p class="block-find-place__point__noresult">' + container.dataset.noresults + '</p>' +
            '</div>';
        container.insertAdjacentHTML('beforeend', html);
        return;
    }

    for (let i = 0; i < Math.min(points.length, limit); i++) {
        let tags = '';

        for (let b = 0; b < points[i].tags.length; b++) {
            tags +=
                '<div class="block-find-place__point__tag">' +
                '<span class="block-find-place__point__tag__text">' + points[i].tags[b].name + '</span>' +
                '</div>'
            ;
        }

        html +=
            '<div class="block-find-place__point">' +
            '<h6 class="block-find-place__point__title">' +
            points[i].title +
            '</h6>' +
            '<div class="block-find-place__point__data-container">' +
            '<div class="block-find-place__point__row">' +
            '<span class="block-find-place__point__label">' + container.dataset.address + ' </span>' +
            '<span class="block-find-place__point__data">' + points[i].fields.adress + ', ' + points[i].city + '</span>' +
            '</div>' +
            '<div class="block-find-place__point__row">' +
            '<span class="block-find-place__point__label">' + container.dataset.phone + ' </span>' +
            '<span class="block-find-place__point__data">' + points[i].fields.phones + '</span>' +
            '</div>' +
            '<div class="block-find-place__point__row">' +
            '<div class="block-find-place__point__tags">' + tags + '</div>' +
            '</div>' +
            '</div>' +
            '</div>'
        ;
    }

    container.insertAdjacentHTML('beforeend', html);
}

function initGoogoleMap(googleMaps) {
    let mapElement = document.getElementById('fp-map'),
        container = document.querySelector('.fp-points'),
        loader = document.querySelector('.block-find-place__loader');

    if (mapElement) {
        let map = new googleMaps.Map(mapElement, {
            center: {lat: 52.10006685381763, lng: 18.714205129598994},
            zoom: 6,
            maxZoom: 18,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles:
                [
                    {
                        "stylers": [
                            {"saturation": 30},
                            {"lightness": 25}
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "stylers": [{"visibility": "off"}]
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "stylers": [{"visibility": "off"}]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text",
                        "stylers": [{"visibility": "off"}]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels",
                        "stylers": [{"visibility": "off"}]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text",
                        "stylers": [{"visibility": "off"}]
                    },
                    {
                        "featureType": "poi",
                        "stylers": [{"visibility": "off"}]
                    }
                ]

        });
        map.addListener("zoom_changed", () => {
            mapZoomChanged(map);
        });

        loadAjaxStores(urlParamCity, urlParamOperator).then(data => {

            let points = data.results;

            if (points.length > 0) {
                for (let i = 0; i < points.length; i++) {

                    const posLatLong = points[i].fields.pos_lat_long.split(',');

                    addMapMarker(parseFloat(posLatLong[0]), parseFloat(posLatLong[1]), points[i].id);
                }

                showMapMarkers(map, googleMaps);
            }

            addPoints(points);
            loader.style.display = 'none';
            container.style.display = 'flex';
        });
        filterPoints(map, googleMaps);
    }
}

function addMapMarker(lat, lng, fpID = 0) {
    mapMarkers.push({lat, lng, fpID});
}

function showMapMarkers(map, googleMaps) {
    if (mapMarkers.length) {

        let bounds = new googleMaps.LatLngBounds()

        for (let i = 0; i < mapMarkers.length; i++) {
            let marker = new googleMaps.Marker({
                position: {lat: mapMarkers[i].lat, lng: mapMarkers[i].lng},
                icon: markerUri,
                map: map
            });

            googleMaps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    onMarkerClick(mapMarkers[i].fpID);
                }
            })(marker, i));

            bounds.extend(marker.getPosition());
            googleMapMarkers.push(marker);
        }

        const renderer = {
            render({count, position}) {
                return new googleMaps.Marker({
                    label: {text: String(count), color: "white", fontSize: "12px"},
                    position,
                    icon: clusterUri,
                    zIndex: Number(googleMaps.Marker.MAX_ZINDEX) + count,
                })
            }
        }

        let options = {
            map: map,
            markers: googleMapMarkers,
            renderer: renderer
        }

        let markerCluster = new MarkerClusterer(options);
        markerClusters.push(markerCluster);
        map.fitBounds(bounds);
        fitBounds = 1;

        if (!mapMarkers.length) {
            map.setCenter({lat: 51.0650101, lng: 21.0645886});
            map.setZoom(13);
        }
    }
}

function onMarkerClick(fpID) {
    let container = document.querySelector('.fp-points');

    if (window.innerWidth < 768){
        container.scrollIntoView();
    }

    let loader = document.querySelector('.block-find-place__loader');
    loader.style.display = 'flex';
    container.style.display = 'none';

    loadAjaxSingleStore(fpID).then(data => {
        let points = data.results;

        addPoints(points);
        loader.style.display = 'none';
        container.style.display = 'flex';
    });
}

function mapZoomChanged(map) {
    if (map.getZoom() > 14 && fitBounds === 1) {
        map.setZoom(14);
        fitBounds = 0;
    }
}

async function loadAjaxStores(city = 'all', operator = 'all') {
    const params = {
        operator: operator,
        city: city
    };

    const url = window.location.origin + '/wp-json/f/v1/points/?' + new URLSearchParams(params);

    const currentUrl = window.location.origin + window.location.pathname;

    let urlParams = {};

    if (city !== 'all' || city !== '') {
        urlParams.city = city;
    }

    if (operator !== 'all') {
        urlParams.operator = operator;
    }

    let urlPart = '?' + new URLSearchParams(urlParams);
    if ((city === 'all' || city === '') && operator === 'all') {
        urlPart = '';
    }

    window.history.replaceState(null, null, currentUrl + urlPart);

    const request = new Request(url, {
        method: 'GET',
    });

    const response = await fetch(request);

    return response.json();
}

async function loadAjaxSingleStore(fpID) {
    const params = {
        id: fpID
    };

    const url = window.location.origin + '/wp-json/f/v1/points/?' + new URLSearchParams(params);

    const request = new Request(url, {
        method: 'GET',
    });

    const response = await fetch(request);

    return response.json();
}
